"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("events");
var Level;
(function (Level) {
    Level[Level["off"] = 0] = "off";
    Level[Level["error"] = 1] = "error";
    Level[Level["warn"] = 2] = "warn";
    Level[Level["info"] = 3] = "info";
    Level[Level["debug"] = 4] = "debug";
})(Level || (Level = {}));
class Logger extends events_1.EventEmitter {
    constructor(level) {
        super();
        this._level = level ? Level[level] : Level.warn;
    }
    set level(level) {
        this._level = Level[level];
    }
    log(level, ...args) {
        const timestamp = Date.now();
        const localDatetime = new Date(timestamp).toLocaleString();
        if (this._level >= Level[level]) {
            // @ts-ignore
            console[level](localDatetime, ...args);
        }
        this.emit("log", level, timestamp, ...args);
    }
    error(...args) {
        this.log("error", ...args);
    }
    warn(...args) {
        this.log("warn", ...args);
    }
    info(...args) {
        this.log("info", ...args);
    }
    debug(...args) {
        this.log("debug", ...args);
    }
}
const logger = new Logger();
exports.default = logger;
//# sourceMappingURL=logging.js.map